module.exports = __webpack_public_path__ + "static/img/service_process.77c81cd3.jpg";